import { ref, inject, computed, watch } from 'vue';
import debounce from 'lodash/debounce';
import { getLinkType } from '../component-lib.esm2.js';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm3.js';
import Alert from '../../components/alert/component-lib.esm.js';
import StackedLayout from './layouts/component-lib.esm.js';
import { useConfiguration } from '../../compositions/component-lib.esm26.js';
import { EVENTS } from '../../config/component-lib.esm.js';
import { localAxios } from '../../utils/component-lib.esm15.js';

//
var script = {
  components: {
    ProfileLinkWrapper,
    StackedLayout,
    Alert
  },
  props: LINK_PROPS,
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const hasSentImpression = ref(false);
    const isExpanded = ref(false);
    const links = ref([]);
    const isLoadingLinks = ref(false);
    const {
      id,
      profile
    } = useLink(props, {
      emit
    });
    const {
      apiBaseUrl
    } = useConfiguration();
    const {
      isInAdmin = false
    } = inject('app', {});
    const hasError = ref(false);
    const defaultError = 'There was an error trying to load this groups links. Please try again soon';
    const errorMessage = ref(null);
    const options = computed(() => {
      return props.link.group_options;
    });
    const limit = computed(() => {
      return options.value.limit || 20;
    });
    const totalLinkCount = computed(() => {
      return options.value.number_of_enabled_links || 0;
    });
    const linksToShow = computed(() => {
      return links.value.slice(0, limit.value);
    });
    const layout = computed(() => {
      return options.value.layout;
    });
    function handleEvent(e) {
      // Only send one impression per link
      if (e === EVENTS.IMPRESSION && hasSentImpression.value) return;
      if (e === EVENTS.IMPRESSION) hasSentImpression.value = true;
      emit('event', e);
    }
    async function loadLinks() {
      if (isLoadingLinks.value) return;
      errorMessage.value = null;
      hasError.value = false;
      isLoadingLinks.value = true;
      try {
        const {
          data
        } = await localAxios.get(`${apiBaseUrl}/public/profiles/${profile.value._id.$oid}/links`, {
          params: {
            group_id: id.value
          }
        });
        links.value = data.links;
      } catch (e) {
        var _e$response, _e$response$data;
        console.error(e);
        if ((_e$response = e.response) !== null && _e$response !== void 0 && (_e$response$data = _e$response.data) !== null && _e$response$data !== void 0 && _e$response$data.error_message) {
          errorMessage.value = e.response.data.error_message;
        }
        hasError.value = true;
      }
      isLoadingLinks.value = false;
    }
    function handleChildLinkClick(e, link, i) {
      emit('click', {
        ...(e || {}),
        link_id: link._id.$oid,
        group_id: id.value,
        group_position: i + 1,
        type: link.type
      });
    }
    watch(isExpanded, val => {
      if (val) {
        if (!links.length || isInAdmin) loadLinks();
      }
    });
    const resetDebounced = debounce(loadLinks, 1000);

    // Reload child links when updates are made to the options
    // This will only happen in the admin
    watch(options, () => {
      // Only reload if the group is expanded
      if (isExpanded.value) resetDebounced();
    }, {
      deep: true
    });
    return {
      handleEvent,
      options,
      layout,
      EVENTS,
      id,
      linksToShow,
      isLoadingLinks,
      getLinkType,
      isExpanded,
      totalLinkCount,
      handleChildLinkClick,
      hasError,
      errorMessage,
      defaultError
    };
  }
};
export { script as default };